import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
} from '@gc-npm/components.text';
import CustomLink from '@gc-npm/components.custom-link';
import { actions as modalActions } from '@gc-npm/reducers.modals-reducer';
import CheckBox from '@/components/CheckBox';
import { actions as modulesActions } from '@/reducers/modules';
import Price, {
  PRICE_FONT_WEIGHT,
  PRICE_SIZE,
} from '@gc-npm/components.price';
import { SCREEN_TYPES } from '@/utils/constants';
import MobilesLinesModal from '../../../Modals/MobilesLinesModal';
import { mobileLinesModalNavigationProps } from '@/utils/mobile-lines-modal';

const MobileLines = ({
  taggingInfo,
  formSkeletonProps,
  alias,
  category,
  mobileLines,
  screenType,
}) => {
  const [checkBoxChecked, setCheckBoxChecked] = useState(false);
  const modulosSelected = useSelector((state) => state.cart.modulos.items);
  const minorLMPrice = useSelector((state) => state.UI.minorLMPrice);
  
  useEffect(() => {
    const lineSelected = modulosSelected.find(
      (module) => mobileLines?.lineToSelect?.id === module.id,
    );
    setCheckBoxChecked(!!lineSelected)
  }, [modulosSelected])

  const dispatch = useDispatch();
  const mobileLinesTexts = {
    text1: 'Añade',
    clicableText: 'línea móvil',
    preprice: 'por',
  };

  const onclickMobileLinesModal = () => {
    dispatch(
      modalActions.addModal({
        id: 'MobileLinesModal',
        Element2Show: MobilesLinesModal,
        modalProps: {
          closeByClickingOutside: true,
          contentPosition: `${screenType === SCREEN_TYPES.MOBILE ? 'bottom--center' : 'center--center'}`,
          inSceneEffect: 'fadeInBottom',
          outSceneEffect: 'fadeOutBottom',
          opacityLayoutColor: 'blur',
          scrollAllowed: false,
          taggingInfoWhenClickingOutside: {
            ...taggingInfo,
            componentName: 'mobileLinesModal',
            componentContent: 'cerrar',
          },
          ...mobileLinesModalNavigationProps,
        },
        elementProps: {
          screenType,
        },
      }),
    );
  };

  const { lineToSelect, linesIds } = mobileLines;
  const onChange = () => {
    let qty = 0;
    const lines = [...linesIds];

    // Establecer qty a 1 si no está chequeado
    if (!checkBoxChecked) {
      qty = 1;
    }

    // Validar todos los qtys: si no es número, setear a 0
    lines.forEach((line) => {
      if (isNaN(line.qty)) {
        line.qty = 0;
      }
    });

    // Buscar y actualizar la línea seleccionada
    const index = lines.findIndex((line) => line.id === lineToSelect.id);
    if (index !== -1) {
      lines[index].qty = qty;
    }

    dispatch(
      modulesActions.selectModules({
        ids: lines,
        category,
        subcategory: 'lme',
      }),
    );

    setCheckBoxChecked(!checkBoxChecked);
  };
  const mobileLinesTaggingInfo = {
    ...taggingInfo,
    componentContent: mobileLinesTexts.clicableText,
    componentProduct: lineToSelect?.id,
  };
  return (
    <div className="MobileLines">
      <div
        className="content"
        role="presentation"
        onClick={(e) => {
          e.stopPropagation();
          return false;
        }}
      >
        <div className="check">
          <CheckBox
            name={`mobilesLinesCheckBox-${alias}`}
            formSkeletonProps={formSkeletonProps}
            taggingInfo={{
              ...mobileLinesTaggingInfo,
            }}
            // required
            checked={checkBoxChecked}
            onChange={onChange}
          />
        </div>

        <CustomLink
          onClick={onclickMobileLinesModal}
          taggingInfo={{
            ...taggingInfo,
            componentContent: mobileLinesTexts.text1,
            componentProduct: '',
          }}
        >
          <div className="buttonContent">
            <div className="text">
              <TextInfo
                text={mobileLinesTexts.text1}
                color={TEXT_COLOR.GREY6}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
                size={TEXT_SIZE.CAPTION3}
              />
            </div>
            <div className="clicableText">
              <TextInfo
                text={mobileLinesTexts.clicableText}
                color={TEXT_COLOR.MOVISTAR_BLUE}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
                size={TEXT_SIZE.CAPTION3}
              />
            </div>
            <div className="price">
              <TextInfo
                text={mobileLinesTexts.preprice}
                color={TEXT_COLOR.GREY6}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
                size={TEXT_SIZE.CAPTION3}
              />
              <Price
                price={minorLMPrice}
                color={TEXT_COLOR.GREY6}
                quote="mes"
                currency="€"
                fontType={PRICE_FONT_WEIGHT.BOLD}
                fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                size={PRICE_SIZE.XS}
              />
            </div>
          </div>

        </CustomLink>

      </div>
      <style jsx>
        {`
        .MobileLines {
          .content {
            display: flex;
            flex-direction: row;
            gap: 0.2rem;
            align-items: center;
            
            .buttonContent{
              display: flex;
              gap: 0.2rem;
              align-items: center;
              flex-wrap: wrap;
              .price {
              display: flex;
              flex-direction: row;
              gap: 0.2rem;
              align-items: center;
            }
            }
           
          }
        }
      `}
      </style>
    </div>
  );
};
export default MobileLines;
